import { gql } from "apollo-boost"

export const UPDATE_MINISTRATION_PLAN = gql`
  mutation UpdateMinistrationPlan($ministrationPlanId: ID!, $createMinistrationPlanData: CreateMinistrationPlanInput!) {
    UpdateMinistrationPlan(
      ministrationPlanId: $ministrationPlanId,
      createMinistrationPlanData: $createMinistrationPlanData
    ) {
      id
      createdAt
      deletedAt
      modifiedAt
      monthlyReviewDueDate
      finalReportDueDate
    }
  }
`
